module.exports = __webpack_public_path__ + "static/media/customer-general-mills.4020fa65.png";